"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoTimeToUtc = void 0;

var _momentStartTime = require("./momentStartTime");

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * returns the utc time for a given moment and video time
 *
 * @param {*} videoTime
 * @param {*} moment
 */
var videoTimeToUtc = function videoTimeToUtc(videoTime, moment) {
  var start = (0, _momentStartTime.momentStartTime)(moment);
  return start + videoTime;
};

exports.videoTimeToUtc = videoTimeToUtc;